import { Wizard } from '@blockswaplab/lsd-wizard'
import { ethers } from 'ethers'
import { useCallback, useState } from 'react'
import { useSigner } from 'wagmi'

import { WITHDRAW_MODE } from '@/constants'
import { notifyHash } from '@/utils/global'

import { useCustomAccount, useSDK } from '.'

export const useWithdrawMethod = () => {
  const { sdk } = useSDK()
  const { isGnosis } = useCustomAccount()
  const { account } = useCustomAccount()
  const address = account?.address

  const { data: signer } = useSigner()

  const [isLoading, setLoading] = useState(false)

  const handleWithdrawLPToken = async (
    mode: WITHDRAW_MODE,
    amount: number,
    liquidStakingManagerAddress: string,
    LSD: any,
    lpToken: string
  ) => {
    const wizard = new Wizard({
      signerOrProvider: signer,
      liquidStakingManagerAddress,
      savETHPoolAddress: LSD.savETHPool,
      feesAndMevPoolAddress: LSD.feesAndMevPool
    })

    let result = undefined
    setLoading(true)

    switch (mode) {
      case WITHDRAW_MODE.STAKING:
        result = await wizard.savETHPool.burnLPToken(lpToken, ethers.utils.parseEther(`${amount}`))
        break
      case WITHDRAW_MODE.FEES_MEV:
        result = await wizard.feesAndMevPool.burnLPTokenForETH(
          lpToken,
          ethers.utils.parseEther(`${amount}`)
        )
        break
    }

    if (!isGnosis) notifyHash(result.hash)
    await result.wait()

    setLoading(false)
    return result
  }
  const handleWithdrawUnstaked = async (params: any) => {
    setLoading(true)
    let transactions: any[] = []

    console.log(params)

    if (params.nodeOperatorBalance > 0) {
      const tx = await sdk?.wizard.nodeOperatorClaimFromRageQuitAssistant(params.assistKey)
      if (!isGnosis) notifyHash(tx.transactionHash)
      transactions = [...transactions, { txName: 'Node operator withdrawal', transaction: tx }]
    }
    if ('PROTECTED_STAKING_LP' in params) {
      const { dETHAmount, assistKey, issuer, lpTokenId, lpAmount } = params['PROTECTED_STAKING_LP']

      if (dETHAmount > 0) {
        const tx = await sdk?.wizard.rageQuitDETHClaim(
          assistKey,
          ethers.utils.parseEther(`${dETHAmount}`)
        )
        if (!isGnosis) notifyHash(tx.transactionHash)
        transactions = [
          ...transactions,
          { txName: 'Protected Staking Withdrawal', transaction: tx }
        ]
      }
      if (lpAmount > 0) {
        const contract = (await sdk?.contractInstance).savETHPool(issuer)

        console.log(lpTokenId, lpAmount, contract)
        const tx = await contract.claimETHFromRageQuit(
          lpTokenId,
          ethers.utils.parseEther(`${lpAmount}`)
        )
        if (!isGnosis) notifyHash(tx.transactionHash)
        transactions = [
          ...transactions,
          { txName: 'Protected Staking Withdrawal', transaction: tx }
        ]
      }

      // if (params.giantLPAmount > 0) {
      //   const contract = (await sdk?.contractInstance).giantSavETHPool()

      //   const tx = await contract.claimETHFromRageQuit(params.blsKey)
      //   transactions = [...transactions, tx]
      // }
    }
    if ('FEES_AND_MEV_LP' in params) {
      const { sETHAmount, assistKey, issuer, lpTokenId, lpAmount } = params['FEES_AND_MEV_LP']

      if (sETHAmount > 0) {
        const tx = await sdk?.wizard.rageQuitSETHClaim(
          assistKey,
          ethers.utils.parseEther(`${sETHAmount}`)
        )
        if (!isGnosis) notifyHash(tx.transactionHash)
        transactions = [...transactions, { txName: 'MEV Staking Withdrawal', transaction: tx }]
      }

      if (lpAmount > 0) {
        const contract = (await sdk?.contractInstance).feesAndMevPool(issuer)

        console.log(lpTokenId, lpAmount)
        const tx = await contract.claimETHFromRageQuit(
          lpTokenId,
          ethers.utils.parseEther(`${lpAmount}`)
        )
        if (!isGnosis) notifyHash(tx.transactionHash)
        transactions = [...transactions, { txName: 'MEV Staking Withdrawal', transaction: tx }]
      }

      // if (params.giantLPAmount > 0) {
      //   const contract = (await sdk?.contractInstance).giantFeesAndMEV()

      //   const tx = await contract.claimETHFromRageQuit(params.blsKey)
      //   transactions = [...transactions, tx]
      // }
    }

    if (params.giantSavLPAmount + params.giantFeesLPAmount > 0 || params.giantLPAmount > 0) {
      if (params.savETHPool && params.giantSavLPAmount > 0) {
        const contract = (await sdk?.contractInstance).giantSavETHPool()

        console.log(params.savETHPool, params.protectedlpTokenId, params.totalETHFunded)

        const ethFundedBN = await sdk?.utils.getGenericERC20WalletBalance(
          params.protectedlpTokenId,
          contract.address
        )

        console.log(ethFundedBN.toString())

        const ethFromRageQuitForBlsKey = await contract.ethFromRageQuitForBlsKey(params.blsKey)
        if (ethFromRageQuitForBlsKey.toString() === '0') {
          const tx = await contract.batchFetchETHFromRageQuit(
            [params.savETHPool],
            [[params.protectedlpTokenId]],
            [[ethFundedBN.toString()]]
          )
          await tx.wait(2)
          console.log('batchFetchETHFromRageQuit', tx)
        } else {
          console.log('batchFetchETHFromRageQuit function has been skipped')
        }

        const tx = await contract.batchClaimETHFromRageQuit([params.blsKey])

        console.log('batchClaimETHFromRageQuit', tx)
        if (!isGnosis) notifyHash(tx.transactionHash)
        transactions = [
          ...transactions,
          { txName: 'Protected Staking Withdrawal', transaction: tx }
        ]
      }

      if (params.feesAndMevPool && params.giantFeesLPAmount > 0) {
        const contract = (await sdk?.contractInstance).giantFeesAndMEV()

        console.log(params.feesAndMevPool, params.feeslpTokenId, params.totalETHFunded)

        let ethFundedBN = await sdk?.utils.getGenericERC20WalletBalance(
          params.feeslpTokenId,
          contract.address
        )

        console.log(ethFundedBN.toString())

        const ethFromRageQuitForBlsKey = await contract.ethFromRageQuitForBlsKey(params.blsKey)
        if (ethFromRageQuitForBlsKey.toString() === '0') {
          const tx = await contract.batchFetchETHFromRageQuit(
            [params.feesAndMevPool],
            [[params.feeslpTokenId]],
            [[ethFundedBN.toString()]]
          )
          await tx.wait(2)
          console.log('batchFetchETHFromRageQuit', tx)
        }

        console.log('after batchFetch', params.blsKey)

        const tx = await contract.batchClaimETHFromRageQuit([params.blsKey])
        console.log('batchClaimETHFromRageQuit', tx)
        if (!isGnosis) notifyHash(tx.transactionHash)
        transactions = [...transactions, { txName: 'MEV Staking Withdrawal', transaction: tx }]
      }
    }

    const txs = await Promise.all(transactions.map(async (tx) => await tx.wait()))

    setLoading(false)

    return txs
  }

  const handleWithdraw = useCallback(
    async (
      mode: WITHDRAW_MODE,
      amount: number,
      liquidStakingManagerAddress?: string | number,
      blsPublicKey?: string | number
    ) => {
      setLoading(true)
      let pool = undefined,
        liquidStakingManager = undefined
      switch (mode) {
        case WITHDRAW_MODE.STAKING:
          pool = (await sdk?.contractInstance).giantSavETHPool()
          break
        case WITHDRAW_MODE.FEES_MEV:
          pool = (await sdk?.contractInstance).giantFeesAndMEV()
          break
        case WITHDRAW_MODE.NODE_OPERATOR:
          liquidStakingManager = (await sdk?.contractInstance).liquidStakingManager(
            liquidStakingManagerAddress
          )
          break
      }
      let result
      if (mode === WITHDRAW_MODE.NODE_OPERATOR)
        result = await liquidStakingManager.withdrawETHForKnot(address, blsPublicKey)
      else result = await pool.withdrawETH(ethers.utils.parseEther(`${amount}`))

      if (!isGnosis) notifyHash(result.hash)
      await result.wait()

      setLoading(false)
      return result
    },
    [sdk]
  )

  return { handleWithdraw, isLoading, setLoading, handleWithdrawLPToken, handleWithdrawUnstaked }
}
